import { Link, Navigate, NavLink, Outlet, useNavigate } from 'react-router';
import { Heart, LifeBuoy, LogOut, Package, Shield, Tag, User } from 'lucide-react';
import { Button } from '@dzseguidores/ui';
import { api } from '@/lib/api-client';
import { clearAccessToken, useIsAuthenticated } from '@/lib/auth';

const links = [
  { to: '/conta/pedidos', label: 'Pedidos', icon: Package },
  { to: '/conta/perfil', label: 'Perfil', icon: User },
  { to: '/conta/seguranca', label: 'Segurança', icon: Shield },
  { to: '/conta/favoritos', label: 'Favoritos', icon: Heart },
  { to: '/conta/cupons', label: 'Cupons', icon: Tag },
  { to: '/conta/suporte', label: 'Suporte', icon: LifeBuoy },
];

export function AccountLayout() {
  const loggedIn = useIsAuthenticated();
  const navigate = useNavigate();

  if (!loggedIn) {
    return <Navigate to="/login" replace />;
  }

  async function handleLogout() {
    try {
      await api.post('/auth/logout');
    } catch {
      // still clear local session
    }
    clearAccessToken();
    navigate('/login', { replace: true });
  }

  return (
    <div className="container-page py-10">
      <div className="mb-8 flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-2xl font-semibold">Minha conta</h1>
        <Button type="button" variant="secondary" size="sm" onClick={() => void handleLogout()}>
          <LogOut className="mr-1.5 h-4 w-4" />
          Sair
        </Button>
      </div>
      <div className="grid gap-8 lg:grid-cols-[220px_1fr]">
        <nav className="flex flex-row gap-2 overflow-x-auto lg:flex-col lg:gap-1">
          {links.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-xl px-3 py-2 text-sm whitespace-nowrap transition ${
                  isActive ? 'bg-surface font-medium text-fg' : 'text-muted hover:text-fg'
                }`
              }
            >
              <Icon className="h-4 w-4 shrink-0" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="glass min-h-[320px] rounded-2xl p-6">
          <Outlet />
        </div>
      </div>
      <p className="mt-6 text-center text-sm text-muted lg:hidden">
        <Link to="/catalogo" className="underline hover:text-fg">
          Voltar ao catálogo
        </Link>
      </p>
    </div>
  );
}
